export default __webpack_public_path__ + "static/media/icons-roadmap.7f7a8596.svg";